import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { ApplicationContractUpdate, AuthorizationCheckRequired, eventBus, PmStore } from "@/state";

export interface Invoice {
  id: string,
  created_ts: string,
  due_on_ts: string,
  name: string,

  post_on_ts: string,
  sent_on_ts: string,
  status: string,
  status_text: string,
  status_id: string,
  total_amount_in_dollars: number,
  total_paid_in_dollars: number,
  type: string,
  type_text: string,
}


export interface LineItem {
  id: string,
  name: string,
  type_id: string,
  status_id: string,
  invoice_id: string,
  description: string,
  amount_in_cents: number
  amount_paid_in_cents: number
  amount_in_dollars: number
  amount_paid_in_dollars: number
  organization_id: string,
  amount_pending_in_dollars: number,
  sales_tax_amount_in_dollars: number,
  total_due_in_dollars: number,
  created_ts: string,
  status: string,
  status_text: string,
  type: string,
  sales_tax_id: string,

}



const queryGetApplicationInvoices = gql`
  query invoices($organizationId: UUID!, $applicationId: UUID!) {
    invoices(organizationId: $organizationId, applicationId: $applicationId) {
        id
        created_ts
        due_on_ts
        name
  
        post_on_ts
        sent_on_ts
        status
        status_text
        status_id
        total_amount_in_dollars
        total_paid_in_dollars
        type
        type_text
    }
  }
`;


const mutationRemoveLineItem = gql`
 mutation deleteLineItem($organizationId: UUID!, $invoiceId: UUID!, $lineItemId: UUID!) {
  deleteLineItem( organizationId: $organizationId, invoiceId: $invoiceId , lineItemId: $lineItemId ) 
 }
`;

const mutationCreateInvoiceWithCharges = gql`mutation createApplicationInvoiceWithCharges(  
  $organizationId: UUID!, $applicationId: UUID!, $name: String, $postOnTs: DateTime, $dueOnTs: DateTime, $lineItems: [LineItemRequestInput!]!) {  
  createApplicationInvoiceWithCharges( organizationId: $organizationId, applicationId: $applicationId, name: $name, postOnTs: $postOnTs, dueOnTs:$dueOnTs, lineItems: $lineItems) 
  {
    
    created_ts
    due_on_ts
    id
    name
    organization_id
    post_on_ts
    sent_on_ts
    status
    status_id
    total_amount_in_cents
    total_amount_in_dollars
    total_paid_in_cents
    total_paid_in_dollars
    updated_ts
  }
}
  `;

const mutationAddLineItemToInvoice = gql`mutation addLineItemToInvoice($organizationId: UUID!, $invoiceId: UUID!, $typeId: UUID, $name: String, $description: String, $amount: Long) {
  addLineItemToInvoice( organizationId: $organizationId, invoiceId: $invoiceId , typeId: $typeId, name: $name, description: $description, amount: $amount )   
  {
    organization_id
    id
    type_id
    status_id
    invoice_id
    description
    amount_in_cents
    amount_paid_in_cents
    amount_in_dollars
    amount_paid_in_dollars
    amount_pending_in_dollars
    sales_tax_amount_in_dollars
    total_due_in_dollars
    created_ts
    name
    status
    status_text
    type
    sales_tax_id

  }
 }
  `;


const queryLineItems = gql`query lineItems($organizationId: UUID!, $invoiceId: UUID!) {
      lineItems(organizationId: $organizationId, invoiceId: $invoiceId) {
          organization_id
          id
          type_id
          status_id
          invoice_id
          description
          amount_in_cents
          amount_paid_in_cents
          amount_in_dollars
          amount_paid_in_dollars
          amount_pending_in_dollars
          sales_tax_amount_in_dollars
          total_due_in_dollars
          created_ts
          name
          status
          status_text
          type
          sales_tax_id
      }
    }`;






   




export function useInvoiceActions() {
  const state = PmStore();
  const [apiGetApplicationInvoices] = useLazyQuery(queryGetApplicationInvoices);
  const [apiRemoveLineItem] = useMutation(mutationRemoveLineItem);
  const [apiCreateInvoiceWithCharges] = useMutation(mutationCreateInvoiceWithCharges);
  const [apiAddLineItemToInvoice] = useMutation(mutationAddLineItemToInvoice);
  const [apiGetLineItems] = useLazyQuery(queryLineItems);


  

  async function CreateInvoiceWithCharges(applicationId: string, name: string, postOnTs: Date, dueOnTs: Date,lineItems: any[]): Promise<Invoice> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiCreateInvoiceWithCharges({ variables: { organizationId, applicationId, name, postOnTs, dueOnTs, lineItems } }) as any;
      return result.data.createApplicationInvoiceWithCharges as Invoice;
    }
    catch (err) {
      toast.error("Api Error, Unable to create invoice.");
    }
  }





  async function GetLineItems(invoiceId: string): Promise<[LineItem]> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiGetLineItems({ variables: { organizationId, invoiceId } }) as any;
      return result.data.lineItems as [LineItem];
    }
    catch (err) {
      toast.error("Api Error, Unable to get line items for invoice.");
    }
  }


  async function RemoveLineItem(invoiceId: string, lineItemId: string): Promise<boolean> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiRemoveLineItem({ variables: { organizationId, invoiceId, lineItemId } }) as any;
      var status = result.data.deleteLineItem as boolean;
      if (!status) throw "Error";
      return status;
    }
    catch (err) {
      toast.error("Api Error, Unable to remove line item from invoice.");
    }
  }



  async function GetApplicationInvoices(applicationId: string): Promise<[Invoice]> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiGetApplicationInvoices({ variables: { organizationId, applicationId } }) as any;
      return result.data.invoices as [Invoice];
    }
    catch (err) {
      toast.error("Api Error, Unable to retrieve application invoices.");
    }
  }




  return {
    GetApplicationInvoices,
    RemoveLineItem,
    GetLineItems,
    CreateInvoiceWithCharges
  };
}




